export default "__VITE_ASSET__DMz4TBIy__"